




















import { Component, Prop, Mixins } from 'vue-property-decorator';
import { CardSliderNavDots, CardSliderArrow } from './components';
import { Images, ComponentProps } from './types';
import mixin from './../mixin';

@Component({
  components: {
    CardSliderNavDots,
    CardSliderArrow,
  },
})
export default class ComponentPartsSliderImages extends Mixins(mixin)
  implements ComponentProps {
  // Props
  @Prop({ type: Boolean, default: false })
  useTag: boolean;

  @Prop({ type: String, default: '#8164a6' })
  public color!: string;

  // computed
  get images(): Images {
    return this.items && this.items.length > 0 ? this.items : [];
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/slider/images/CardSlider.vue